import { render } from "./Stickers.vue?vue&type=template&id=4e9a96d8&scoped=true"
import script from "./Stickers.vue?vue&type=script&lang=js"
export * from "./Stickers.vue?vue&type=script&lang=js"

import "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=4e9a96d8&scoped=true&lang=css&external"
import "./Stickers.vue?vue&type=style&index=1&id=4e9a96d8&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e9a96d8"]])

export default __exports__